/**
 * 2026-10-14 — preview routing retired.
 * ?view=moojo-origin forced the legacy atlas and bypassed the origin fiche.
 * A session that already stored the flag must drop it, or the next click
 * would put the old template back.
 */
(function () {
  try {
    sessionStorage.removeItem('moojo-origin-preview');
  } catch (e) {
    /* ignore */
  }
  if (document.documentElement.dataset) {
    delete document.documentElement.dataset.moojoOriginPreview;
  }
  try {
    var url = new URL(window.location.href);
    if (url.searchParams.get('view') !== 'moojo-origin') return;
    url.searchParams.delete('view');
    window.location.replace(url.pathname + url.search + url.hash);
  } catch (e) {
    /* ignore */
  }
})();
